export enum BreakpointQuery {
  Compact = '(max-width: 599px)',
  Medium = '(max-width: 839px)',
  Expanded = '(max-width: 1199px)',
  Large = '(max-width: 1599px)',
}
